var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"col-lg-8 col-md-8 ml-auto mr-auto"},[_c('h1',[_vm._v("За одоо болсоон Баатраатай яриарай")]),_c('router-link',{attrs:{"to":"/signIn"}},[_c('h3',[_vm._v("Нэвтрэх")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }